import { useState } from "react";
import { Button, Card, Form, ListGroup } from "react-bootstrap";
import { BsSave } from "react-icons/bs";
import { FaTrashAlt } from "react-icons/fa";
import { FaCheck, FaRegCopy } from "react-icons/fa6";

const ProfileDetails = ({ currentUserData }) => {
  const [copiedField, setCopiedField] = useState(null);

  const handleCopy = (e, text, field) => {
    e.stopPropagation();
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => {
      setCopiedField(null);
    }, 1500);
  };
  return (
    <>
      <div className="w-50 m-auto mt-5 py-3">
        <ListGroup className="mb-2">
          <ListGroup.Item action className="position-relative">
            <p className="m-0" style={{ fontSize: 12 }}>
              Email Address
            </p>
            <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
              {currentUserData?.email}
            </Form.Label>
            {copiedField === "emailAddress" ? (
              <FaCheck
                className="position-absolute text-success"
                title="Copied!"
                style={{ bottom: 10, right: 10 }}
              />
            ) : (
              <FaRegCopy
                className="position-absolute"
                style={{ bottom: 10, right: 10, cursor: "pointer" }}
                title="Copy Email Address"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopy(e, currentUserData?.email, "emailAddress");
                }}
              />
            )}
          </ListGroup.Item>
        </ListGroup>
        <ListGroup className="mb-2">
          <ListGroup.Item action className="position-relative">
            <p className="m-0" style={{ fontSize: 12 }}>
              Secret Key
            </p>
            <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
              {currentUserData?.secretKey}
            </Form.Label>
            {copiedField === "secretKey" ? (
              <FaCheck
                className="position-absolute text-success"
                title="Copied!"
                style={{ bottom: 10, right: 10 }}
              />
            ) : (
              <FaRegCopy
                className="position-absolute"
                style={{ bottom: 10, right: 10, cursor: "pointer" }}
                title="Copy Secret Key"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopy(e, currentUserData?.secretKey, "secretKey");
                }}
              />
            )}
          </ListGroup.Item>
        </ListGroup>
        <Card className="border rounded-2 mb-3">
          <Card.Body>
            <div className="hstack justify-content-between mb-2">
              <h6 className="m-0">{`Emergency Kit`}</h6>
              <Button
                variant="outline-primary"
                style={{ fontSize: 13 }}
                title="Save Emergency Kit"
                className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
              >
                <BsSave /> Save Emergency Kit
              </Button>
            </div>
            <p style={{ fontSize: 13 }} className="m-0">
              Your Emergency Kit contains information you’ll need to sign in to
              your Password Manager [PM] account.
            </p>
          </Card.Body>
        </Card>
        <div className="hstack justify-content-end">
          <Button
            variant="outline-danger"
            style={{ fontSize: 13 }}
            title="Permanently Delete Account"
            className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
          >
            <FaTrashAlt /> Permanently Delete Account
          </Button>
        </div>
      </div>
    </>
  );
};

export default ProfileDetails;
